import type { MessageDescriptor, IntlShape } from 'react-intl';

/**
 * Returns a formatted Intl Message from a defineMessages Object for the given messageId
 * @param messagesObj Object with defined Intl Messages
 * @param messageId The Message Id fpr the message you want to have formatted
 * @param formatMessage The formatMessage function
 * @returns The formatted message if a result was found, otherwise the original messageId
 */
export const getFormattedMessage = (
  messagesObj: { [key: string]: MessageDescriptor },
  messageId: string,
  formatMessage: IntlShape['formatMessage'],
): string => {
  const [, message] = Object.entries(messagesObj).find(([, msg]) => msg.id === messageId) || [];
  return message ? formatMessage(message) : messageId;
};
